module.exports = __webpack_public_path__ + "img/icon_2_17.f48f3a65.png";